import React from 'react';
import CategoryPage from '../components/CategoryPage';

const CoworkingPage = () => {
  return <CategoryPage categoryId="coworking" />;
};

export default CoworkingPage;